<!-- Ride Along follow card — mirrors Flutter TripStatusCard(isRideAlong:true).
     Compact timer pill by default; the green arrow expands to full details. -->

<!-- COMPACT: timer pill + green expand arrow -->
<div class="raf-pill" *ngIf="!expanded" (click)="toggleExpand()">
  <span class="raf-pill-dot" [class.paused]="paused"></span>
  <span class="raf-pill-time">{{ duration }}</span>
  <button class="raf-expand" type="button" (click)="toggleExpand(); $event.stopPropagation()" aria-label="Expand">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0B3A11" stroke-width="2.4"
      stroke-linecap="round" stroke-linejoin="round">
      <polyline points="15 3 21 3 21 9" />
      <polyline points="9 21 3 21 3 15" />
      <line x1="21" y1="3" x2="14" y2="10" />
      <line x1="3" y1="21" x2="10" y2="14" />
    </svg>
  </button>
</div>

<!-- EXPANDED: full details -->
<div class="raf-card" [class.paused]="paused" *ngIf="expanded">
  <div class="raf-badge" *ngIf="paused">
    <span class="raf-badge-dot"></span> Captain Paused
  </div>

  <div class="raf-top">
    <button class="raf-collapse" type="button" (click)="toggleExpand()" aria-label="Collapse">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1f2933" stroke-width="2.4"
        stroke-linecap="round" stroke-linejoin="round">
        <polyline points="4 14 10 14 10 20" />
        <polyline points="20 10 14 10 14 4" />
        <line x1="14" y1="10" x2="21" y2="3" />
        <line x1="3" y1="21" x2="10" y2="14" />
      </svg>
    </button>
  </div>

  <div class="raf-coords-row">
    <span class="raf-label">Coordinates :</span>
    <span class="raf-coords">{{ coordinates }}</span>
  </div>

  <div class="raf-stats">
    <div class="raf-stat">
      <span class="raf-label">Underway:</span>
      <span class="raf-value">{{ duration }}</span>
    </div>
    <div class="raf-stat raf-stat--end">
      <span class="raf-label">Speed:</span>
      <span class="raf-value">{{ speedLabel }}</span>
    </div>
  </div>

  <div class="raf-stats">
    <div class="raf-stat">
      <span class="raf-label">Distance:</span>
      <span class="raf-value">{{ distanceLabel }}</span>
    </div>
    <div class="raf-stat raf-stat--end">
      <span class="raf-label">Water temp:</span>
      <span class="raf-value">{{ waterTempLabel }}</span>
    </div>
  </div>

  <div class="raf-actions">
    <button class="raf-mates" type="button" (click)="onViewMates()">
      <img class="raf-btn-icon" src="assets/trip/dockmates_icon.svg" alt="" /> Trip Mates
    </button>
    <button class="raf-waypoints" type="button" (click)="onViewWaypoints()">
      <img class="raf-btn-icon" src="assets/home/shared/wavepoint_logo.svg" alt="" /> Added Waypoints
    </button>
  </div>
</div>
